var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order",class:_vm.cOrder,on:{"click":_vm.change}},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-arrow"}})]),_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-arrow"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }